export { Menu6 as default } from './Menu6';
